import React, { useEffect, useState } from "react";
// import gym from "../../Assets/images/gym.jpg";
// import girlWithBags from "../../Assets/images/girlWithBags.jpg";
// import laptop from "../../Assets/images/laptop.jpg";
import { Link } from "react-router-dom";
import noimage from "../../Assets/images/Image_not_available.png";

import { api_url } from "../../Constants/web_services";

const HomeProjects = () => {
  const [rec_pro, setRec_pro] = useState([]);

  useEffect(() => {
    fetch(api_url + "/api/recent_projects")
      .then((response) => response.json())
      .then((data) => {
        setRec_pro(data?.data);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  return (
    <>
      <div className="aon-news-section-wrap sf-curve-pos">
        <div className="container">
          {/*Title Section Start*/}
          <div className="section-head">
            <div className="row">
              <div className="col-lg-6 col-md-12">
                <span className="aon-sub-title">projects</span>
                <h2 className="sf-title">Recent Project</h2>
              </div>
              <div className="col-lg-6 col-md-12 d-flex">
                <div>
                  <h3>Revolutionary Software</h3>
                  <p>Transform industries with our innovative projects.</p>
                </div>
                <div>
                  <h3>Customized Excellence</h3>
                  <p>Tailored solutions that fit your goals perfectly.</p>
                </div>
                <div>
                  <h3>Tomorrow's Tech Today</h3>
                  <p>Future-proof projects that keep you ahead.</p>
                </div>
              </div>
            </div>
          </div>
          {/*Title Section End*/}
          <div className="section-content">
            <div className="row">
              {/* COLUMNS 1 */}
              {rec_pro?.length > 0 &&
                rec_pro?.map((projects, index) => (
                  <div className="col-md-4" key={index}>
                    <div className="media-bg-animate">
                      <div
                        className="aon-blog-section-1 shine-hover"
                        style={{ height: "500px" }}
                      >
                        <div className="aon-post-media shine-box">
                          <Link to={`/profile/${projects?.company_id}`}>
                            <img
                              src={
                                projects?.image
                                  ? api_url + "/" + projects?.image
                                  : noimage
                              }
                              alt=""
                              style={{ width: "450px", height: "300px" }}
                            />
                          </Link>
                        </div>
                        <div className="aon-post-meta">
                          <ul className="ps-0">
                            <li className="aon-post-category">
                              Latest Project{" "}
                              <span className="text-warning fw-800">|</span>{" "}
                              {projects?.title}
                            </li>
                          </ul>
                          <ul className="ps-0  d-flex justify-content-start">
                            <li className="aon-post-author">
                              <Link className="text-decoration-none text-022279">
                                By
                                <span className="text-warning fw-800 text-uppercase">
                                  {projects?.name}
                                </span>{" "}
                                <span className="text-capitalize">
                                  {projects?.company?.name}
                                </span>
                              </Link>{" "}
                            </li>
                          </ul>
                        </div>
                        <div className="aon-post-info">
                          <h4 className="aon-post-title s-18">
                            <Link
                              to={`/profile/${projects?.company_id}`}
                              className="text-decoration-none fw-700"
                            >
                              {projects?.short_desc}
                            </Link>
                          </h4>
                          {/* <div className="aon-post-text">
                              <p>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                                do eiusmod{" "}
                              </p>
                            </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeProjects;
